import { useEffect, useRef } from 'react';

import useLoading from 'lib/hooks/useLoading';

import Button from 'components/shared/Button/Button';
import Icon from 'components/shared/Icon/Icon';
import Typography from 'components/shared/Typography/Typography';

const ActionWrapper = ({ title, hasExport, handleExportPdf, onClose, children }) => {
  const contentRef = useRef(null);

  const { loading: isExporting, startLoading, stopLoading } = useLoading();

  const onExportPdf = async () => {
    try {
      startLoading();
      await handleExportPdf();
    } catch (error) {
      console.error('Error exporting an activity log to a PDF:', error);
    } finally {
      stopLoading();
    }
  };

  useEffect(() => {
    if (contentRef.current) {
      contentRef.current.scrollTop = contentRef.current.scrollHeight;
    }
  }, [children]);

  return (
    <div className="right-14 top-0 z-20 flex h-full w-[512px] min-w-[340px] max-w-[512px] flex-1 flex-col items-center gap-4 bg-white shadow-[-2px_0px_4px_rgba(42,92,138,0.1)] sm:absolute sm:min-w-[320px] sm:max-w-[320px] md:absolute md:min-w-[400px] md:max-w-[400px]">
      <div className="flex w-full items-center justify-between border-b border-solid border-white border-b-neutral-200 bg-white px-5 py-[19px]">
        <Typography color="neutral-800" size="small" weight="semibold">
          {title}
        </Typography>

        <div className="flex items-center gap-2">
          {hasExport && (
            <Button
              outlined
              size="xs"
              color="neutral"
              variant="tertiary"
              icon="export-mono"
              text="Export"
              textClassName="text-neutral-700"
              isLoading={isExporting}
              onClick={onExportPdf}
            />
          )}

          <Icon icon="close-mono" color="neutral-700" onClick={onClose} />
        </div>
      </div>
      <div ref={contentRef} className="flex w-full flex-1 flex-col overflow-y-auto">
        {children}
      </div>
    </div>
  );
};

export default ActionWrapper;
